import { useContext } from "react";
import { AppActionsContext } from "@shared/context";

export default function useAppActionsContext() {
	const ctx = useContext(AppActionsContext);

	return ctx;
}
